export default {
  title: 'Nieuwe categorie',
  form: {
    menus: {
      label: "Menu's",
    },
    printer: {
      label: 'Printer',
    },
    type: {
      label: 'Type',
    },
    name: {
      label: 'Naam',
      placeholder: 'Voer categorienaam in',
    },
    description: {
      label: 'Omschrijving',
      placeholder: 'Voer omschrijving in',
    },
    has_combo_tax: {
      label: 'Heeft combotax',
    },
    modifier_groups: {
      label: 'Modificatorgroepen',
    },
    image: {
      label: 'Afbeelding',
    },
    identifiers: {
      label: 'Identificatoren',
    },
    has_separate_schedule: {
      label: 'Wijkt af van menurooster',
    },
  },
  buttons: {
    save: 'Opslaan',
    close: 'Sluiten',
  },
  feedback: {
    missing_info: 'Ontbrekende informatie',
  },
  toasts: {
    category_got_created: 'Categorie aangemaakt',
    category_got_updated: 'Categorie bijgewerkt',
  },
};
